import { decodeJwt as joseDecodeJwt } from 'jose';

export function decodeJwt<T>(token: string | undefined | null): T | undefined {
  if (!token) {
    return undefined;
  }
  try {
    return joseDecodeJwt(token) as T;
  } catch {
    return undefined;
  }
}
